<template>
  <div class="OrderManage" v-if="detail">
    <div class="ship" v-if="detail.track_number===null || detail.track_number===''">
      <el-form ref="form" class="form" :rules="rules" :model="request_data" label-width="120px">
        <template v-if="!detail.virtual_product">
          <div class="main">
            <el-form-item label="Tracking No." prop="LogisticCode">
              <el-input class="item" size="medium" v-model="request_data.LogisticCode"
                        placeholder="Enter Tracking No."></el-input>
            </el-form-item>
            <el-form-item label="Courier Name" prop="ShipperCode">
              <el-select class="item" size="medium" v-model="request_data.ShipperCode" placeholder="Select a Courier">
                <el-option
                    v-for="item in shipper_list"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
  
          <div class="title">Sender Info</div>
          <div class="more">
            <el-form-item label="Name">
              <el-input class="item" size="medium" v-model="request_data.Sender.Name"
                        placeholder="Name"></el-input>
            </el-form-item>
            <el-form-item label="Mobile">
              <el-input class="item" size="medium" v-model="request_data.Sender.Mobile"
                        placeholder="Enter Mobile"></el-input>
            </el-form-item>
          </div>
          <div class="more">
            <el-form-item label="Province">
              <el-input class="item" size="medium" v-model="request_data.Sender.ProvinceName"
                        placeholder="Enter Province"></el-input>
            </el-form-item>
            <el-form-item label="City">
              <el-input class="item" size="medium" v-model="request_data.Sender.CityName"
                        placeholder="Enter City"></el-input>
            </el-form-item>
          </div>
          <div class="more">
            <el-form-item label="District">
              <el-input class="item" size="medium" v-model="request_data.Sender.ExpAreaName"
                        placeholder="Enter District"></el-input>
            </el-form-item>
            <el-form-item label="Address">
              <el-input class="item" size="medium" v-model="request_data.Sender.Address"
                        placeholder="Enter Detail Address"></el-input>
            </el-form-item>
          </div>
        </template>

        <div class="title">Recipient Info</div>
        <div class="more">
          <el-form-item label="Name">
            <el-input class="item" size="medium" v-model="request_data.Receiver.Name"
                      placeholder="Name"></el-input>
          </el-form-item>
          <el-form-item label="Mobile">
            <el-input class="item" size="medium" v-model="request_data.Receiver.Mobile"
                      placeholder="Enter Mobile"></el-input>
          </el-form-item>
        </div>
        <div class="more">
          <el-form-item label="Province">
            <el-input class="item" size="medium" v-model="request_data.Receiver.ProvinceName"
                      placeholder="Enter Province"></el-input>
          </el-form-item>
          <el-form-item label="City">
            <el-input class="item" size="medium" v-model="request_data.Receiver.CityName"
                      placeholder="Enter City"></el-input>
          </el-form-item>
        </div>
        <div class="more">
          <el-form-item label="District">
            <el-input class="item" size="medium" v-model="request_data.Receiver.ExpAreaName"
                      placeholder="Enter District"></el-input>
          </el-form-item>
          <el-form-item label="Address">
            <el-input class="item" size="medium" v-model="request_data.Receiver.Address"
                      placeholder="Enter Detail Address"></el-input>
          </el-form-item>
        </div>

        <el-form-item label-width="300px">
          <template v-if="!detail.virtual_product">
            <el-button type="primary" round class="submit" @click="onSubmit">Enable Auto Tracking</el-button>
          </template>
          <template v-else>
            <el-button v-if="detail.order_state == 1" type="primary" round class="submit" @click="markAsUsed">Mark as Used</el-button>
            <div v-else >Alerady Used!</div>
          </template>
        </el-form-item>
      </el-form>
    </div>
    <div class="track" v-if="detail.track_number!==null && detail.track_number!==''">
      <div class="track_info">
        <p>Tracking Number: <span style="color: #409eff">{{detail.track_number}}</span></p>
        <p>Courier Name: <span style="color: #409eff">{{detail.track_courier_text}}</span></p>
        <div class="track_state">
          <p>Order State: <span style="color: #409eff">{{detail.order_state_text}}</span></p>
        </div>
      </div>
      <div class="track_table">
        <el-table
            v-loading="load_state"
            height="500"
            :data="track_table"
            style="width: 100%">
          <el-table-column
              prop="AcceptTime"
              label="Time"
              width="180">
          </el-table-column>
          <el-table-column
              prop="AcceptStation"
              label="Detail">
          </el-table-column>
        </el-table>
      </div>
      <div class="track_action">
        <el-button size="medium" type="primary" @click="onUpdate">Manual Update</el-button>
        <el-button size="medium" @click="onChange">Change Number</el-button>
      </div>
    </div>

  </div>
</template>

<script>
  import {getOrderDetail, orderTrack, orderTrackUpdate, orderMarkUsed} from "@/utils/api";

  export default {
    props: ['orderid', 'recipient'],
    data: () => {
      return {
        load_state: false,
        detail: false,
        track_table: [],
        shipper_list: [
          {name: '顺丰速运(SF)', code: 'SF'},
          {name: '中通快递(ZTO)', code: 'ZTO'},
          {name: '申通快递(STO)', code: 'STO'},
          {name: '圆通速递(YTO)', code: 'YTO'},
          {name: 'EMS', code: 'EMS'},
        ],
        rules: {
          LogisticCode: [
            {required: true, message: 'Tracking number is Required', trigger: 'change'},
          ],
          ShipperCode: [
            {required: true, message: 'Courier Name is Required', trigger: 'blur'},
          ]
        },
        request_data: {
          "LogisticCode": '',
          "ShipperCode": '',
          "PayType": "1",
          "ExpType": "1",
          "Sender": {
            "Name": "",
            "Mobile": "",
            "ProvinceName": "",
            "CityName": "",
            "ExpAreaName": "",
            "Address": ""
          },
          "Receiver": {
            "Name": "",
            "Mobile": "",
            "ProvinceName": "",
            "CityName": "",
            "ExpAreaName": "",
            "Address": ""
          }
        }
      }
    },
    methods: {
      markAsUsed() {
        orderMarkUsed(this.orderid).then(res => {
          if (res.errcode===0 && res.success){
            this.$message.success('Success Marked');
            this.onGetInfo()
          }

        })
      },
      onUpdate() {
        this.load_state = true;
        orderTrackUpdate(this.detail.track_number, this.detail.track_courier, this.request_data.Receiver.Mobile).then(res => {
          if (res.errcode === 0) {
            this.$message.success('Tracking Updated');
            this.onGetInfo()
          } else {
            this.load_state = false;
            this.$message.error('Error in Updating Tracking Info')
          }
        });

      },
      onChange() {
        this.$confirm(`Are you sure you want to change the tracking number?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.detail['track_number'] = null
        }).catch(() => {
        });
      },
      onSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            orderTrack(this.request_data).then(res => {
              if (res.errcode===0 && res.success){
                this.$message.success('Tracking Enabled');
                this.onGetInfo()
              }

            })
          }
        });
      },
      onGetInfo() {
        getOrderDetail(this.orderid).then(res => {
          this.load_state = false;
          let detail = res.detail;
          this.request_data.order_id = this.orderid;
          this.request_data.Receiver.Name = detail.user_name;
          this.request_data.Receiver.Mobile = detail.tel_number;
          this.request_data.Receiver.ProvinceName = detail.province_name;
          this.request_data.Receiver.CityName = detail.city_name;
          this.request_data.Receiver.ExpAreaName = detail.county_name;
          this.request_data.Receiver.Address = detail.detail_info;
          if (detail.track_number !== null && detail.track_number !== '') {
            this.shipper_list.forEach(v => {
              if (v.code === detail.track_courier) {
                detail.track_courier_text = v.name
              }
            });
          }
          if (detail.track_info !== null && detail.track_info !== '') {
            this.track_table = detail.track_info.Traces.reverse();
          }
          this.detail = detail;
        })
      }
    },
    beforeMount() {
      this.onGetInfo()
    }
  };
</script>


<style lang="scss" scoped>
  @import "_OrderManage.scss";
</style>